export default __webpack_public_path__ + "static/media/caption-icon.029b71cd.svg";